export default "__VITE_ASSET__f148c286__"